export const EXTERNAL_LINKS = {
  PRIVACY_POLICY: 'https://www.skylarq.ai/privacy-policy',
  TERMS_OF_USE: 'https://www.skylarq.ai/terms-of-use',
  DESKTOP_DOWNLOAD: 'https://assistant.skylarq.ai',
  DESKTOP_DOWNLOAD_DMG: 'https://d3ggayjxpj1xsu.cloudfront.net/Skylarq-Assistant-latest-mac-arm64.dmg',
  DESKTOP_DOWNLOAD_DMG_X64: 'https://d3ggayjxpj1xsu.cloudfront.net/Skylarq-Assistant-latest-mac-x64.dmg',
} as const;
